// Import SASS
import '../sass/style.scss';

// Import scripts
// import './modules/navigation';
import './modules/skip-link-focus-fix';
import './modules/maps';
import './modules/simpletabs';
import objectFitImages from 'object-fit-images';
import Siema from 'siema';
import inView from 'in-view';

// Veelgebruikte modules:
// ------------------------
// Lightbox		-->		import baguetteBox from 'baguettebox.js';
// Viewport		-->		import inView from 'in-view';
// Smoothscroll	-->		import MoveTo from 'moveto';
// Sticky div	-->		import Sticky from 'sticky-js';
// Slider		-->		import { tns } from 'tiny-slider/src/tiny-slider.module.js';
// Modals		-->		import modals from 'Modals';

// Hamburger menu
document.querySelector("#nav-toggle").addEventListener("click", function () {
	this.classList.toggle("active");
	let mainNav = document.querySelector('.main-navigation');
	mainNav.classList.toggle('toggled');
});

var faqToggle = document.querySelectorAll(".faq__question");
for (var i = 0; i < faqToggle.length; i++) {
    faqToggle[i].onclick = function () {
        this.nextElementSibling.classList.toggle("active");
        this.querySelector('svg').classList.toggle('active');
    };
}

// Object-fit fix
objectFitImages();

if (document.querySelector(".video__start1")) { 
	document.querySelector(".video__start1").addEventListener("click", function () {
		document.querySelector("#videoContainer").innerHTML = '<iframe width="560" height="315" src="//www.youtube.com/embed/cv4v97KC02w?rel=0&amp;showinfo=0&autoplay=1" frameborder="0" allowfullscreen></iframe>';
	});
}
if (document.querySelector(".video__start2")) { 
	document.querySelector(".video__start2").addEventListener("click", function () {
		document.querySelector("#videoContainer2").innerHTML = '<iframe width="560" height="315" src="//www.youtube.com/embed/s3kx62AV1v4?rel=0&amp;showinfo=0&autoplay=1" frameborder="0" allowfullscreen></iframe>';
	});
}

if (document.querySelector(".video__start3")) { 
	document.querySelector(".video__start3").addEventListener("click", function () {
		document.querySelector("#videoContainer3").innerHTML = '<iframe width="560" height="315" src="//www.youtube.com/embed/tY79ZV8AXgs?rel=0&amp;showinfo=0&autoplay=1" frameborder="0" allowfullscreen></iframe>';
	});
}


inView('.home__text').once('enter', function() { document.querySelector(".home__text").classList.add("fadeInUp") });
inView('.cta__img').once('enter', function() { document.querySelector(".cta__img").classList.add("fadeIn") });
inView('.header__logoimg').once('enter', function() { document.querySelector(".header__logoimg").classList.add("fadeIn") });

// WooCommerce single product add to cart via AJAX
if (document.body.classList.contains('single-product') && typeof window.jQuery !== 'undefined') {
	const $ = window.jQuery;
	const wcAjaxParams = window.wc_add_to_cart_params || window.wc_cart_fragments_params;
	const forms = document.querySelectorAll('form.cart');

	if (wcAjaxParams && wcAjaxParams.wc_ajax_url && forms.length) {
		const addToCartEndpoint = wcAjaxParams.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart');

		forms.forEach((form) => {
			const addToCartButton = form.querySelector('.single_add_to_cart_button');

			if (!addToCartButton || form.classList.contains('grouped_form')) {
				return;
			}

			form.addEventListener('submit', function (event) {
				if (addToCartButton.classList.contains('disabled')) {
					return;
				}

				const variationIdInput = form.querySelector('input[name="variation_id"]');
				if (variationIdInput && !variationIdInput.value) {
					return;
				}

				event.preventDefault();

				const $form = $(form);
				const $button = $(addToCartButton);
				const requestData = $form.serializeArray();
				const buttonName = addToCartButton.getAttribute('name');
				const buttonValue = addToCartButton.getAttribute('value');
				const hasAddToCartField = requestData.some((field) => field.name === 'add-to-cart');
				const hasProductIdField = requestData.some((field) => field.name === 'product_id');

				if (buttonName && buttonValue && !hasAddToCartField) {
					requestData.push({ name: buttonName, value: buttonValue });
				}

				if (buttonValue && !hasProductIdField) {
					requestData.push({ name: 'product_id', value: buttonValue });
				}

				const loadingStartedAt = Date.now();
				let addToCartSucceeded = false;

				$button.removeClass('added').addClass('loading');

				$.ajax({
					type: 'POST',
					url: addToCartEndpoint,
					data: $.param(requestData),
					dataType: 'json',
					success: function (response) {
						if (!response) {
							return;
						}

						if (response.error && response.product_url) {
							window.location = response.product_url;
							return;
						}

						if (response.error) {
							form.submit();
							return;
						}

						if (response.fragments) {
							Object.keys(response.fragments).forEach((selector) => {
								$(selector).replaceWith(response.fragments[selector]);
							});
						}

						addToCartSucceeded = true;
						$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $button]);
					},
					error: function () {
						form.submit();
					},
					complete: function () {
						const clearLoadingState = function () {
							$button.removeClass('loading');

							if (addToCartSucceeded) {
								$button.addClass('added');
							}
						};

						const elapsedTime = Date.now() - loadingStartedAt;
						const minLoadingMs = 250;

						if (elapsedTime < minLoadingMs) {
							setTimeout(clearLoadingState, minLoadingMs - elapsedTime);
							return;
						}

						clearLoadingState();
					}
				});
			});
		});
	}
}

if (document.querySelector(".siema__header")) { 

const headerSiema = new Siema({
		  selector: '.siema__header',
		  interval: 10000,
		  duration: 500,
		  perPage: 1,
		  startIndex: 0,
		  draggable: true,
		  threshold: 20,
		  loop: true
		});

// listen for keydown event
setInterval(() => headerSiema.next(), 5000);

}
